import { useEffect, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import "./print.css";
import { OrpBarcodeFormat, StandardBarcode } from "./barcodeFormates";
import constant from "../../../constants/constant";
const Index = ({
  downloadBarcode,
  togglePrice,
  barcodeFormat,
  showStoreName,
}: any) => {
  const targetRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => targetRef.current,
    documentTitle:
      "barcodes" + Math.floor(100000 + Math.random() * 900000).toString(),
  });

  const handleRenderBarcodeFormat = (index: number, item: any) => {
    if (barcodeFormat === constant.BARCODE_FORMAT.SRP_ORP) {
      return (
        <OrpBarcodeFormat
          key={index}
          item={item}
          togglePrice={togglePrice}
          index={index}
          store_region={Number(
            item?.store_region || constant.STORE_REGION.INDIA
          )}
          showStoreName={showStoreName}
        />
      );
    }
    return (
      <StandardBarcode
        key={index}
        item={item}
        togglePrice={togglePrice}
        index={index}
        store_region={Number(item?.store_region || constant.STORE_REGION.INDIA)}
        showStoreName={showStoreName}
      />
    );
  };

  useEffect(() => {
    if (downloadBarcode && downloadBarcode.length > 0) {
      // generatePDF(targetRef, options)
      handlePrint();
    }
  }, [downloadBarcode]);

  return (
    <>
      <div className="container barcode-container ps-2 " ref={targetRef}>
        {downloadBarcode?.map((item: any, index: number) => {
          return handleRenderBarcodeFormat(index, item);
        })}
      </div>
    </>
  );
};

export default Index;
